import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ForkliftDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftDto';

@Component({
    selector: 'shared-forklift-right',
    templateUrl: './shared.forklift.right.component.html',
    styleUrls: ['./shared.forklift.right.component.scss']
})
export class SharedForkliftRightComponent {

    @Input() public value: ForkliftDto;
    @Input() public open: boolean = false;
    @Output() public openChange = new EventEmitter<boolean>();

    toggle() {
        this.openChange.emit(!this.open);
    }
    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
